import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class ThermodynamicsFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>

        <div style = {{paddingBottom: 40}}>

        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Temperature conversion (C to F)</TableRowColumn>
        <TableRowColumn> <img style = {{paddingLeft: 30}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Temperature conversion (C to K)</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Thermal Expansion</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Volume Expansion</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Thermodynamics 1<sup>st</sup> law</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/5.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Heat gained or lost (with temperature change)</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/6.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Heat gained or lost (phase change)</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/7.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 400}}>Entropy</TableRowColumn>
        <TableRowColumn><img style = {{paddingLeft:  30}} src = {require("./Formulas/8.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>

  </div>


      </MuiThemeProvider>

    );
  }
}

export default ThermodynamicsFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Thermodynamics/ThermodynamicsFormulas.js